import axios from 'axios';
import store from "../store";

const isTestEnv = location.pathname.match('timber-');
const isLocalEnv = location.pathname.match('mkdesigner');
const isStageEnv = location.pathname.match('xstage');

const DASHBOARD_PATH = (isLocalEnv ? 'http://localhost:8080'
  : isTestEnv ? 'https://test.mhmfun.com/home-test'
    : isStageEnv ? 'https://staging.mhmfun.com/home-stage'
      : 'https://www.musthavemenus.com/home')
  + '/api/';

const getLocationFolders = (locationId) => {
  return axios.get(`${DASHBOARD_PATH}locations/${locationId}/folder`,
    {
      headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') }
    }
  );
}

const createLocationFolder = (locationId, name, memberId, parentId = "") => {
  return axios.post(`${DASHBOARD_PATH}locations/${locationId}/folder`, {},
    {
      params: {
        id: locationId,
        name: name,
        parentId: parentId,
        memberId: memberId
      },
      headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') }
    }
  )
}

const putDesignInFolder = (designId, folderId, oldFolderId = "") => {
  const designIds = [designId];
  return axios.post(`${DASHBOARD_PATH}designs/folder`, {},
    {
      params: {
        ids: designIds.join(','),
        folderId,
        oldFolderId: oldFolderId || undefined
      },
      headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') }
    }
  )
}

const removeDesignFromFolder = (designId) => {
  const designIds = [designId];
  return axios.delete(`${DASHBOARD_PATH}designs/folder/remove`,
    {
      params: {
        ids: designIds.join(','),
      },
      headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') }
    }
  )
}

// const updateOrder = (dto) => {
//   return axios.put(`${PRINT_PATH}/orders`, dto, 
//     { headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') } }
//   );
// }

// const removeItem = (orderId, itemId) => {
//   return axios.delete(`${PRINT_PATH}/orders/${orderId}/item/${itemId}`,
//   { headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') } })
// }

const getMemberLocations = (memberId) => {
  return axios.get(`${DASHBOARD_PATH}members/${memberId}/locations`,
    { headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') } }
  );
}

const getScreens = () => {
  return axios.get(`${DASHBOARD_PATH}dsa/screens`,
    { headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') } }
  );
}

const getScreensTotal = () => {
  return axios.get(`${DASHBOARD_PATH}dsa/screens/total`,
    { headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') } }
  );
}

const getScreensPerLocation = (locationId) => {
  return axios.get(`${DASHBOARD_PATH}dsa/screens/location/${locationId}`,
    { headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') } }
  );
}

const setScreenContent = (serial, dto) => {
  return axios.post(`${DASHBOARD_PATH}dsa/screens/${serial}/content`, dto,
    { headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') } }
  );
}

const updateScreenContent = (serial, dto) => {
  return axios.put(`${DASHBOARD_PATH}dsa/screens/${serial}/content`, dto,
    { headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') } }
  );
}

const createBoard = (dto) => {
  return axios.post(`${DASHBOARD_PATH}dsa/boards`, dto,
    { headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') } }
  );
}

const getTextBlockByName = (name) => {
  return axios.get(`${DASHBOARD_PATH}v1/text-blocks/name`, 
    {
      headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') },
      params: { name: name }
    }
  );
}

const getOnlineMenuStatus = () => {
  return axios.get(`/app/online/location/stats/${store.getState().locationId || window.data.design.locationId}?oo=true`,
    {
      headers: { 'Authorization': 'Bearer ' + window.localStorage.getItem('tkn') },
    }
  );
}

export default {
  getLocationFolders,
  createLocationFolder,
  putDesignInFolder,
  removeDesignFromFolder,
  getMemberLocations,
  getScreens,
  getScreensTotal,
  getScreensPerLocation,
  setScreenContent,
  updateScreenContent,
  createBoard,
  getTextBlockByName,
  getOnlineMenuStatus,
  // createOrder,
  // updateOrder,
  // removeItem,
}
